/* BHÍOS reveal guard — site-wide failure-safe for reveal-on-scroll.
   Rule (Kevin, 2026-07-05): no section may ever stay invisible because a
   reveal animation failed to fire. Covers the custom section reveal hooks
   (data-wwm/proof/rv/num-reveal) and Prestige's native [reveal-on-scroll].
   If an element sits in the viewport across two ticks (~1.4s) and is still
   at opacity < 0.5, it is forced visible with inline styles — inline wins
   over any stylesheet state, so this holds even when a transition or
   observer misfires. Normal reveals are untouched: anything that animates
   in within ~1.4s never trips the guard.

   Perf pass 2026-09-04: this used to be a setInterval(700) that ran for the
   whole life of the page, measuring ~130 elements every 700ms forever — and
   because it wrote inline styles inside the same loop it read rects in, each
   write invalidated layout for the next read (layout thrash on a permanent
   timer). Two changes, no behavioural difference:
     1. reads are batched, writes applied after the loop;
     2. ticking is a burst, not a heartbeat — it runs for a few seconds after
        load and for a few seconds after each scroll/resize, which is the only
        time an element can newly enter the viewport. Idle pages cost nothing. */
(function () {
  'use strict';
  var SEL = '[data-wwm-reveal],[data-proof-reveal],[data-rv-reveal],[data-num-reveal],[reveal-on-scroll],.bhios-animate';
  var TICK_MS = 700;
  var BURST_MS = 4200;      /* ~6 ticks after any scroll/resize */
  var INITIAL_MS = 12000;   /* longer window right after load, while assets settle */
  var strikes = new WeakMap();
  var timer = null;
  var stopAt = 0;

  function tick() {
    var els = document.querySelectorAll(SEL);
    var vh = window.innerHeight || 0;
    var fix = [];

    /* read phase — no writes, so no layout thrash */
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var r = el.getBoundingClientRect();
      if (r.width === 0 || r.height === 0 || r.bottom <= 0 || r.top >= vh) {
        strikes.delete(el);
        continue;
      }
      if (parseFloat(getComputedStyle(el).opacity) >= 0.5) {
        strikes.delete(el);
        continue;
      }
      var n = (strikes.get(el) || 0) + 1;
      strikes.set(el, n);
      if (n >= 2) fix.push(el);
    }

    /* write phase */
    for (var j = 0; j < fix.length; j++) {
      var f = fix[j];
      f.classList.add('is-visible');
      f.classList.add('bhios-visible');
      f.style.opacity = '1';
      f.style.transform = 'none';
      strikes.delete(f);
    }

    if (Date.now() >= stopAt) {
      clearInterval(timer);
      timer = null;
    }
  }

  function burst(ms) {
    stopAt = Math.max(stopAt, Date.now() + ms);
    if (!timer) timer = setInterval(tick, TICK_MS);
  }

  function start() {
    burst(INITIAL_MS);
    var pending = false;
    function wake() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        burst(BURST_MS);
      });
    }
    window.addEventListener('scroll', wake, { passive: true });
    window.addEventListener('resize', wake, { passive: true });
    window.addEventListener('orientationchange', wake, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) burst(BURST_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
